import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import SignatureBuilder from "@/pages/SignatureBuilder";
import LogoStudio from "@/pages/LogoStudio";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/signature" element={<SignatureBuilder />} />
          <Route path="/logo" element={<LogoStudio />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#0A1326',
            color: '#F8F9FA',
            border: '1px solid rgba(212,175,55,0.25)',
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
